
(() => {
  // initialize only once
  if (window.__wdBuyButtonsBundleSubmitInit) return;
  window.__wdBuyButtonsBundleSubmitInit = true;

  function extractDimensionNumbers(text) {
    const cleaned = String(text)
      .replace(/ס"מ/g, ' ')
      .replace(/ס״מ/g, ' ')
      .replace(/×/g, 'x');
    const segments = cleaned.split(/[,·]/).flatMap((segment) => segment.trim().split(/\s*x\s*/i));
    const nums = [];
    for (const segment of segments) {
      const match = segment.match(/(\d+)/);
      if (match) nums.push(match[1]);
    }
    return nums;
  }

  function formatDimensionsText(raw) {
    if (!raw) return '';
    let dims = String(raw).trim();
    if (dims.startsWith('מידות:')) dims = dims.slice('מידות:'.length).trim();
    if (dims.startsWith('גודל:')) dims = dims.slice('גודל:'.length).trim();
    dims = dims.replace(/X/g, '×').replace(/x/g, '×').replace(/ס"מ/g, 'ס״מ');

    const nums = extractDimensionNumbers(dims);
    const isVerbose = /[,]|גובה|רוחב|אורך|ראש מיטה/.test(dims);
    if (isVerbose && nums.length >= 2 && nums.length <= 4) {
      dims = `${nums.slice(0, 3).join('×')} ס״מ`;
      return `מידות: ${dims}`;
    }

    if (dims.includes('רוחב')) {
      dims = dims
        .replace(/רוחב\s+/g, '')
        .replace(/ס״מ\s*אורך\s*/g, '×')
        .replace(/ס"מ\s*אורך\s*/g, '×')
        .replace(/\s*אורך\s*/g, '×')
        .replace(/ס"מ/g, 'ס״מ');
      if (!dims.includes('ס״מ')) dims = `${dims} ס״מ`;
    } else if (dims.includes('×') && !dims.includes('ס״מ')) {
      dims = `${dims} ס״מ`;
    }
    return dims ? `מידות: ${dims}` : '';
  }

  function parseCartDataParts(pipeData) {
    const parts = pipeData.split('|').map((s) => s.trim()).filter(Boolean);
    let color = '';
    let dims = '';
    let sku = '';
    const other = [];
    for (const part of parts) {
      if (part.startsWith('מק״ט:')) sku = part;
      else if (part.startsWith('מידות:') || part.startsWith('גודל:')) dims = formatDimensionsText(part);
      else if (part.startsWith('צבע:')) color = part;
      else other.push(part);
    }
    return { color, dims, sku, other };
  }

  const CART_LINE_SEP = '::WD::';

  // Keep empty middle slots so line1/line2/line3 stay aligned (avoid SKU landing in line2).
  function stackCartData(line1, line2, line3) {
    return [line1 || '', line2 || '', line3 || ''].join(CART_LINE_SEP);
  }

  function formatCartDataForParam(param, pipeData) {
    const { color, dims, sku, other } = parseCartDataParts(pipeData);
    if (param === 'handle') {
      return stackCartData('', dims, sku);
    }
    if (/^m[1-5]$/.test(param)) {
      return stackCartData('', dims, sku);
    }
    if (param === 'color') {
      const line1 = color || other.join(' · ');
      return stackCartData(line1, dims, sku);
    }
    if (param === 'railing') {
      // Prefer explicit "צבע מעקה:" (also survives middot-joined cartData from liquid)
      let railingColor = color && color.includes('מעקה') ? color : '';
      if (!railingColor) {
        for (const part of [color, ...other]) {
          if (!part) continue;
          const match = String(part).match(/צבע מעקה:\s*[^|·]+/);
          if (match) {
            railingColor = match[0].trim();
            break;
          }
        }
      }
      return stackCartData(railingColor || '', dims, sku);
    }
    return stackCartData(other.join(' · ') || color, dims, sku);
  }

  const BUNDLE_PICKER_PARAMS = ['handle', 'color', 'railing', 'm1', 'm2', 'm3', 'm4', 'm5', 'shelves', 'drawers'];

  function parseVariantId(raw) {
    const s = String(raw ?? '').trim();
    if (!s || !/^\d+$/.test(s)) return null;
    const n = Number(s);
    return Number.isSafeInteger(n) ? n : null;
  }

  function getBundlePickerRoot(form) {
    const sectionId =
      form.closest('.product-form')?.getAttribute('data-section-id') ||
      form.closest('[data-section-id]')?.getAttribute('data-section-id');
    if (sectionId) {
      const byProductInfo = document.querySelector(`product-info[data-section="${sectionId}"]`);
      if (byProductInfo) return byProductInfo;
    }
    return (
      form.closest('product-info') ||
      form.closest('[id^="shopify-section-"]') ||
      form.closest('.shopify-section') ||
      document.documentElement
    );
  }

  function getCheckedPickerRadio(picker, param) {
    const urlVal = new URL(window.location.href).searchParams.get(param);
    if (urlVal) {
      const fromUrl = picker.querySelector(`input[type="radio"][value="${urlVal}"]`);
      if (fromUrl && !fromUrl.disabled) {
        fromUrl.checked = true;
        return fromUrl;
      }
    }
    return picker.querySelector('input[type="radio"]:checked');
  }

  // listen to all form submits and detect product submit that are from bundled products
  document.addEventListener(
    'submit',
    (event) => {
      // check if the event is a submit event of bundled product
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('is') !== 'product-form') return;
      const pickerRoot = getBundlePickerRoot(form);
      // check if the wrapper has some bundle options
      if (!pickerRoot.querySelector('wd-product-variant-picker[param]')) return;
      if (typeof FoxTheme === 'undefined' || FoxTheme.settings?.cartType === 'page') return;

      // Stop theme’s own submit listener from also running (we POST JSON ourselves + reuse `handleFormSubmission`).
      event.preventDefault();
      event.stopImmediatePropagation();
      // `form` is the `product-form` custom element — we reuse its cart UI + `fetch` pipeline from theme.js.
      const /** @type {any} */ pf = form;
      /** @type {Record<string, string>} param name → checked radio value (usually variant id, or "" for “none”). */
      const selections = {};
      /** @type {Record<string, string>} param name → cart data label. */
      const cart_data = {};
      // build object of selected bundle options (fixed param order; sync from URL on submit)
      for (const param of BUNDLE_PICKER_PARAMS) {
        const picker = pickerRoot.querySelector(`wd-product-variant-picker[param="${param}"]`);
        if (!picker) continue;
        const checked = getCheckedPickerRadio(picker, param);
        if (!checked) continue;
        selections[param] = checked.value == null ? '' : String(checked.value);

        const cart_data_label = checked.getAttribute('cartData');
        if (cart_data_label) cart_data[param] = cart_data_label;
      }

      const formVariantId = parseVariantId(new FormData(form).get('id'));
      if (formVariantId != null && !('handle' in selections)) {
        selections.handle = String(formVariantId);
      }
      const checkedColorRadio = pickerRoot.querySelector(
        'wd-product-variant-picker[param="color"] input[type="radio"]:checked'
      );

      const parentVariantId = parseVariantId(selections.handle);

      const colorName =
        checkedColorRadio?.getAttribute('textvalue')?.trim() ||
        checkedColorRadio?.getAttribute('colorValue')?.trim() ||
        '';

      const checkedHandleRadio = pickerRoot.querySelector(
        'wd-product-variant-picker[param="handle"] input[type="radio"]:checked'
      );
      const handlePaintName =
        checkedHandleRadio?.getAttribute('colorValue')?.trim() ||
        checkedHandleRadio?.getAttribute('textvalue')?.trim() ||
        '';

      const checkedRailingColor = pickerRoot
        .querySelector('wd-product-variant-picker[param="railing"] input[type="radio"]:checked')
        ?.getAttribute('colorValue')
        ?.trim();

      // Customer-facing bed color on the main line: facade finish first, then handle paint.
      const bedColorName = colorName || handlePaintName;

      let quantity = parseInt(new FormData(form).get('quantity') || '1', 10) || 1;

      // generate bundle id to link all items together (rand + const unique string for that bundle option)
      const _bundle_id = `${Math.random().toString(36).substring(2, 10)}_${parentVariantId.toString(36).substring(0, 10)}`;

      // build array of selected bundle options
      /** @type { { id: number, quantity: number, properties: Record<string, string>, parent_id?: number, instructions?: { can_remove: boolean, can_update_quantity: boolean } }[] } */
      const items = [];
      for (const param of BUNDLE_PICKER_PARAMS) {
        if (!(param in selections)) continue;
        const variantId = parseVariantId(selections[param]);
        if (variantId == null) continue;

        /** @type { id: number, quantity: number, properties: Record<string, string> } */
        const opt = {
          id: variantId,
          quantity,
          properties: {
            _bundle_id,
            _bundle_param: param,
          },
        };
        if (param !== 'handle' && parentVariantId != null && variantId !== parentVariantId) {
          opt.parent_id = parentVariantId;
          opt.instructions = { can_remove: false, can_update_quantity: false };
        }

        if (param == 'color' && colorName) {
          opt.properties['_color'] = colorName;
        }

        if (param == 'railing') {
          if (checkedRailingColor) {
            opt.properties['_railing_color'] = checkedRailingColor;
          }
        }

        if (param == 'handle') {
          opt.properties['_main'] = true;
          if (bedColorName) {
            opt.properties['_bed_color'] = bedColorName;
          }
          let pipeData = cart_data.handle;
          if (pipeData && !pipeData.includes('מידות:') && !pipeData.includes('גודל:')) {
            const swatchComment = checkedHandleRadio
              ?.closest('label')
              ?.querySelector('.wd-swatch--radio-comment')
              ?.textContent?.trim();
            if (swatchComment) {
              const formatted = formatDimensionsText(swatchComment);
              pipeData = pipeData ? `${pipeData}|${formatted}` : formatted;
            }
          }

          const optionParts = [];
          let dimensionsLine = '';
          let skuLine = '';

          const addFromCartData = (data, isMainHandle) => {
            if (!data) return;
            for (const part of data.split('|').map((s) => s.trim()).filter(Boolean)) {
              if (part.startsWith('מק״ט:')) {
                if (isMainHandle) skuLine = part;
              } else if (part.startsWith('גודל:') || part.startsWith('מידות:')) {
                if (isMainHandle) {
                  const dim = formatDimensionsText(part);
                  dimensionsLine = dimensionsLine ? `${dimensionsLine} · ${dim}` : dim;
                }
              } else if (!isMainHandle) {
                // Facade / railing color belong on their sub-items, not the main options line
                if (part.startsWith('צבע מעקה:') || part.startsWith('צבע:')) continue;
                optionParts.push(part);
              }
            }
          };

          // Facade color/SKU are shown on the color sub-item (ETZ-728)
          addFromCartData(cart_data.railing, false);

          if (
            bedColorName &&
            !optionParts.some((part) => part.startsWith('צבע:') && !part.startsWith('צבע מעקה:'))
          ) {
            optionParts.unshift(`צבע: ${bedColorName}`);
          }

          const mattressLabels = [];
          for (const key of ['m1', 'm2', 'm3', 'm4', 'm5']) {
            if (!cart_data[key]) continue;
            const firstPart = cart_data[key].split('|').map((s) => s.trim()).filter(Boolean)[0];
            if (
              firstPart &&
              !firstPart.startsWith('מק״ט:') &&
              !firstPart.startsWith('מידות:') &&
              !firstPart.startsWith('גודל:')
            ) {
              mattressLabels.push(firstPart);
            }
          }
          if (mattressLabels.length > 1) {
            optionParts.push(`${mattressLabels.length} מזרנים`);
          } else if (mattressLabels.length === 1) {
            optionParts.push(mattressLabels[0]);
          }

          // תוספת מדפים / מגירות (ארונות) - מפורטות בשמן, לא נספרות כמזרנים
          for (const key of ['shelves', 'drawers']) {
            if (!cart_data[key]) continue;
            const firstPart = cart_data[key].split('|').map((s) => s.trim()).filter(Boolean)[0];
            if (
              firstPart &&
              !firstPart.startsWith('מק״ט:') &&
              !firstPart.startsWith('מידות:') &&
              !firstPart.startsWith('גודל:')
            ) {
              optionParts.push(firstPart);
            }
          }

          addFromCartData(pipeData, true);

          const line1 = optionParts.length ? optionParts.join(' · ') : '';
          const line2 = dimensionsLine || '';
          const line3 = skuLine || '';
          if (line1 || line2 || line3) {
            opt.properties['_cart_data'] = stackCartData(line1, line2, line3);
          }
          const dims = parseCartDataParts(pipeData || '').dims;
          if (dims) {
            opt.properties['_cart_dims'] = dims.replace(/^מידות:\s*/, '');
          }
        } else if (cart_data[param] || param === 'railing' || param === 'color') {
          let paramCartData = cart_data[param] || '';
          if (param === 'railing') {
            const railingColorAttr = opt.properties['_railing_color'] || checkedRailingColor;
            if (railingColorAttr && !paramCartData.includes('צבע מעקה:')) {
              paramCartData = paramCartData
                ? `${paramCartData}|צבע מעקה: ${railingColorAttr}`
                : `צבע מעקה: ${railingColorAttr}`;
            }
          }
          if (param === 'color' && colorName && !/(?:^|\|)צבע:/.test(paramCartData)) {
            paramCartData = paramCartData ? `${paramCartData}|צבע: ${colorName}` : `צבע: ${colorName}`;
          }
          if (paramCartData) {
            opt.properties['_cart_data'] = formatCartDataForParam(param, paramCartData);
          }
        }

        items.push(opt);
      }

      if (!items.length) {
        if (typeof pf.displayFormErrors === 'function') {
          pf.displayFormErrors('לא סומן שום מוצר');
        }
        return;
      }

      // if there is only one item, remove the bundle id property
      if (items.length == 1) {
        delete items[0].properties._bundle_id;
        delete items[0].properties._bundle_param;
      }

      // get optional upsale products
      if (window.WdUpsale) {
        const upsale = new WdUpsale();
        const selectedUpsaleProducts = upsale.getSelectedUpsaleProducts();
        upsale.disabledUpsaleInputs();
        items.push(...selectedUpsaleProducts.map(id => ({
          id,
          quantity: 1,
          properties: {
            _upsale: true,
          },
        })));
      }

      // `handleCartError` in theme.js reads `this.formData.get('id')` — minimal stub when the real form is not the payload source.
      pf.formData = new FormData();
      pf.formData.set('id', String(items[0].id));

      pf.lastSubmittedElement = event.submitter || pf.submitButtonElement;
      if (typeof pf.displayFormErrors === 'function') pf.displayFormErrors();

      // // section to rerender on cart page (not needed as the whole cart gets rerendered - relevant if ATC from drawer?? )
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      // Same shape as `assets/products-bundle-selection.js` (JSON body, one `fetch` inside `handleFormSubmission`).
      const payload = {
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
        items,
      };

      const config = FoxTheme.utils.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify(payload);
      // flag that prevent cart open on error case
      config.dontRefreshCartOnError = true;

      const btn = pf.submitButtonElement;
      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('btn--loading');
      }

      pf.handleFormSubmission(config);
    },
    true
  );

  function updateQuantityMax() {
    document.querySelectorAll('input[name="quantity"]').forEach(input => {
      const lowestMax = Math.min(
        ...Array.from(document.querySelectorAll('wd-product-variant-picker input[type="radio"]:checked'))
          .map(input => input.getAttribute('max') ?? 999)
      );
      input.setAttribute('max', lowestMax);
      input.setAttribute('data-max', lowestMax);

      const value = Number(input.value);
      if (value > lowestMax) {
        input.value = lowestMax;
      }
    });
  }
  // on variant change update the max attribute of the quantity input to be the lowest of the selected options
  document.addEventListener('variantChange', updateQuantityMax);
  updateQuantityMax();

  /** Kbite sets inline color on hover; beat it with setProperty(..., 'important'). */
  function wireKbiteNotifyHover(btn) {
    if (!btn || btn.getAttribute('data-wd-kbite-hover') === '1') return;
    btn.setAttribute('data-wd-kbite-hover', '1');

    function setDefault() {
      btn.style.setProperty('color', '#fff', 'important');
      btn.style.setProperty('background-color', '#000', 'important');
      btn.style.setProperty('border-color', '#000', 'important');
    }

    function setHover() {
      btn.style.setProperty('color', '#000', 'important');
      btn.style.setProperty('background-color', '#fff', 'important');
      btn.style.setProperty('border-color', '#000', 'important');
    }

    setDefault();
    btn.addEventListener('mouseenter', setHover);
    btn.addEventListener('mouseleave', setDefault);
    btn.addEventListener('focus', setHover);
    btn.addEventListener('blur', setDefault);

    const url = new URL(window.location);
    if (url.searchParams.get("notify") == "true") {
      btn.click();
      url.searchParams.delete("notify");
      window.history.replaceState({}, '', url.toString());
    }
  }

  function scanKbiteNotifyButtons() {
    document.querySelectorAll('.product-form__buttons .gw-button-widget.wd-buy-btn').forEach(wireKbiteNotifyHover);
  }

  scanKbiteNotifyButtons();
  var kbiteBtnObs = new MutationObserver(scanKbiteNotifyButtons);
  if (document.body) {
    kbiteBtnObs.observe(document.body, { childList: true, subtree: true });
  }
})();
